import { useEffect } from 'react';

// This custom React hook removes the card title element from the DOM if `waitForAPI` is false.
//
// Reason:
// Since Bronson version 21.0.0, every card is forced to render a title (`.c-card__title`),
// even if no title content is provided. This results in an empty header element (if title="") above the
// card content, causing unwanted vertical spacing.
//
// To fix this, we manually remove the parent element of each `.c-card__title` from the DOM,
// effectively eliminating the empty space and restoring the intended layout.

export const useRemoveCardTitle = (waitForAPI?: boolean) => {
  useEffect(() => {
    if (waitForAPI) return;

    const titleElements = document.querySelectorAll('.c-card__title');
    titleElements.forEach((titleElement) => {
      const header = titleElement.parentElement;
      if (header) {
        header.remove();
      }
    });
  }, [waitForAPI]);
};
